<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0;">
    <div class="mx-auto" style="width: 70%;">
        <p class="mb-0">
          <a [href]="'/home'" class="btn btn-xs text-light shadow-none align-middle px-0">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
        <h2 class="text-light mb-0">Nueva solicitud de código artículo</h2>
    </div>
  </div>
  <form [formGroup]="requestCodeForm">
        <div class="row my-3 mx-auto" style="width: 70%;">
            <div class="col">
                <div class="row mb-2">
                    <label><strong>DATOS GENERALES</strong></label>
                </div>
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-5">
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select mdbValidate placeholder="Grupo contable" [filter]="true" formControlName="accountingGroupSelected">
                                    <mdb-option [value]="" disabled>Seleccione grupo contable</mdb-option>
                                    <mdb-option *ngFor="let item of accountingGroup" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Grupo contable</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('accountingGroupSelected')?.touched && requestCodeForm?.get('accountingGroupSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un grupo contable
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Agrupación Comercial" [filter]="true" formControlName="comercialGroupSelected">
                                    <mdb-option [value]="" disabled>Seleccione agrupación comercial</mdb-option>
                                    <mdb-option *ngFor="let item of commercialGroup" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Agrupación comercial</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('comercialGroupSelected')?.touched && requestCodeForm?.get('comercialGroupSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Agrupación comercial
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Agrupación financiera" [filter]="true" formControlName="financialGroupSelected">
                                    <mdb-option [value]="" disabled>Seleccione agrupación financiera</mdb-option>
                                    <mdb-option *ngFor="let item of financialGroup" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Agrupación financiera</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('financialGroupSelected')?.touched && requestCodeForm?.get('financialGroupSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una agrupación financiera
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Agrupación Ejecutiva" [filter]="true" formControlName="executiveGroupSelected">
                                    <mdb-option [value]="" disabled>Seleccione agrupación ejecutiva</mdb-option>
                                    <mdb-option *ngFor="let item of executiveGroup" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Agrupación ejecutiva</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('executiveGroupSelected')?.touched && requestCodeForm?.get('executiveGroupSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una agrupación ejecutiva
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Tipo" [filter]="true" (valueChange)="buildLineCode($event)" formControlName="codeTypeSelected">
                                    <mdb-option [value]="" disabled>Seleccione tipo</mdb-option>
                                    <mdb-option *ngFor="let item of codeTypes" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Tipo</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('codeTypeSelected')?.touched && requestCodeForm?.get('codeTypeSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un tipo
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Línea" [filter]="true" (valueChange)="buildFamilyCode($event)" formControlName="codeLineSelected">
                                    <mdb-option [value]="" disabled>Seleccione línea</mdb-option>
                                    <mdb-option *ngFor="let item of codeLines" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Línea</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('codeLineSelected')?.touched && requestCodeForm?.get('codeLineSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una línea
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Familia" [filter]="true" (valueChange)="buildSubFamilyCode($event)" formControlName="codeFamilySelected">
                                    <mdb-option [value]="" disabled>Seleccione familia</mdb-option>
                                    <mdb-option *ngFor="let item of codeFamilies" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Familia</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('codeFamilySelected')?.touched && requestCodeForm?.get('codeFamilySelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una familia
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Subfamilia" [filter]="true" formControlName="codeSubFamilySelected">
                                    <mdb-option [value]="" disabled>Seleccione subfamilia</mdb-option>
                                    <mdb-option *ngFor="let item of codeSubFamilies" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Subfamilia</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('codeSubFamilySelected')?.touched && requestCodeForm?.get('codeSubFamilySelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una subfamilia
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-4">
                        <input mdbCheckbox class="form-check-input custom-shadow" type="checkbox" value="" formControlName="inventoryItemCheck"/>
                        <label class="form-check-label" for="active-checkbox"> Art. Inventario</label>
                    </div>
                    <div class="col-4">
                        <input mdbCheckbox class="form-check-input custom-shadow" type="checkbox" value="" formControlName="inventorySalesCheck"/>
                        <label class="form-check-label" for="active-checkbox"> Art. Ventas</label>
                    </div>
                    <div class="col-4">
                        <input mdbCheckbox class="form-check-input custom-shadow" type="checkbox" value="" formControlName="inventoryShoppingCheck"/>
                        <label class="form-check-label" for="active-checkbox"> Art. Compras</label>
                    </div>
                </div>
                <div class="row mx-0" style="justify-content: space-between;">
                    <div class="col-5">
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Método de gestión" [filter]="true" formControlName="managementMethodSelected">
                                    <mdb-option [value]="" disabled>Seleccione método de gestión</mdb-option>
                                    <mdb-option *ngFor="let item of managementMethods" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Método de gestión</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('managementMethodSelected')?.touched && requestCodeForm?.get('managementMethodSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un método de gestión
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-5">
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Origen" [filter]="true" formControlName="originSelected">
                                    <mdb-option [value]="" disabled>Seleccione origen</mdb-option>
                                    <mdb-option *ngFor="let item of origins" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Origen</label>
                            </mdb-form-control>
                            <div *ngIf="requestCodeForm?.get('originSelected')?.touched && requestCodeForm?.get('originSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un origen
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mx-0" style="justify-content: space-between;">
                    <mdb-form-control class="custom-shadow">
                        <mdb-select [multiple]="true" [filter]="true" formControlName="warehouseSelected">
                            <mdb-select-all-option>Seleccionar todos</mdb-select-all-option>
                            <mdb-option *ngFor="let item of warehouses" [value]="item.ID">
                                {{ item.NAME }}
                            </mdb-option>
                        </mdb-select>
                        <label mdbLabel class="form-label">Bodegas</label>
                    </mdb-form-control>
                    <div *ngIf="requestCodeForm?.get('warehouseSelected')?.touched && requestCodeForm?.get('warehouseSelected')?.errors?.['required']" class="floating-alert">
                        <span class="error-icon me-2">⚠️</span>Seleccione al menos una bodega
                    </div>
                </div>
            </div>
            <div class="col-3 ml-auto mt-4">
                <div class="row mt-1">
                    <label mdbLabel>Fecha: {{dateNow}}</label>
                </div>
                <div class="row">
                    <label mdbLabel>Solicitante: {{requesterUser}}</label>
                </div>
                <div class="row mt-4">
                    <div class="mb-2">
                        <label>¿Desea buscar un código existente?</label>
                    </div>
                    <div class="mb-2">
                        <mdb-form-control class="custom-shadow">
                            <input
                                mdbInput
                                type="text"
                                id="search-code-input"
                                class="form-control"
                                formControlName="searchCode"
                            />
                            <label mdbLabel class="form-label" for="search-code-input">Ingrese código base</label>
                        </mdb-form-control>
                    </div>
                    <div style="text-align: center;">
                        <button type="button" class="shadow-0 btn btn-md btn-primary" (click)="searchRegisterBySerialCode()">
                            Buscar
                        </button>
                    </div>
                </div>
                <div class="row" style="margin-top: 100px;">
                    <div style="text-align: center;">
                        <button type="button" class="shadow-0 btn btn-md btn-success" (click)="createRequestCode()">
                            ENVIAR SOLICITUD
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row my-3 mx-auto" style="width: 70%;">
            <div class="row" style="justify-content: space-between;">
                <div class="col">
                    <div class="row mb-3">
                        <div class="col-2">
                            <label><strong>GESTIÓN DE CÓDIGOS</strong></label>
                        </div>
                        <div class="col">
                            <button type="button" class="shadow-0 btn btn-md btn-primary" (click)="addOrEditCode('add')">
                                <i class="fas fa-plus"></i>
                                Agregar código
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="datatable table-editor">
                            <table
                                class="table datatable-table"
                                mdbTable
                                mdbTableSort
                                #table="mdbTable"
                                #sort="mdbTableSort"
                                [dataSource]="codes"
                                [pagination]="pagination"
                                [sort]="sort"
                                width="100%"
                                border-collapse="collapse" 
                            >
                                <thead class="datatable-header">
                                    <tr>
                                    <ng-container *ngFor="let header of headers">
                                        <th
                                            [mdbTableSortHeader]="header.field"
                                            [disableSort]="header.disableSort"
                                            scope="col"
                                            class="bg-gris-02 py-2 align-middle th_3"
                                            style="white-space: normal; padding-left: 0; font-weight: bold;"
                                        >
                                            {{ header.label.replace("_", " ") | titlecase }}
                                        </th>
                                    </ng-container>
                                    </tr>
                                </thead>
                            
                                <tbody class="datatable-body">
                                    <tr *ngIf="loading">
                                        <td colspan="5" class="p-0 pt-1">
                                            <div class="px-2 bg-gris-01 py-5 text-center">
                                                <div width="150" class="spinner-border mt-5 opacity-50" role="status"></div>
                                                <p class="lead text-gris-02 text-center mb-5">
                                                    Cargando resultados...
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                
                                <tbody class="datatable-body">
                                    <tr
                                        *ngFor="let register of codes; let index = index"
                                        scope="row"
                                        [cdkTrapFocus]="editElementIndex === index"
                                        [cdkTrapFocusAutoCapture]="editElementIndex === index"
                                        [ngClass]="{ 'edited-row': editElementIndex === index }"
                                    >
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.serial }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.description }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.foreign }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.un }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.un_est }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.un_for }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.factor }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1" style="white-space: normal; padding-right: 10px; padding-left: 0px; max-width: 100px; word-wrap: break-word;">
                                            <ng-container>
                                                {{ register.sku_management }}
                                            </ng-container>
                                        </td>
                                        <td class="table-cell py-1 px-2" style="max-width: 50px;">
                                            <div class="row">
                                                <div class="col" style="max-width: 30px;">
                                                    <button class="px-1 py-0 mt-1 btn btn-lg btn-warning"
                                                        type="button"
                                                        (click)="addOrEditCode('edit', register.id)">
                                                        <i class="far fa-edit"></i>
                                                    </button>
                                                </div>
                                                <div class="col" style="max-width: 30px;">
                                                    <button class="px-1 py-0 mt-1 btn btn-lg btn-danger"
                                                        type="button"
                                                        (click)="deleteObject(register.id, register.serial)">
                                                        <i class="far fa-trash-alt"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    
                            <mdb-table-pagination
                                #pagination
                                rowsPerPageText = 'Registros por Pagina'
                                ofText = 'de'
                                [entries]="10"
                            ></mdb-table-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </form>

  <mdb-loading [show]="loadingFull" [fullscreen]="true">
      <div class="loading-spinner">
          <div class="spinner-border loading-icon" role="status"></div>
          <span class="loading-text">Cargando datos...</span>
      </div>
  </mdb-loading>